export default "__VITE_ASSET__BDjwf$7F__"